import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Form, Popover, Table} from 'antd';
import moment from 'moment';
import {queryAccountList} from '@api/core/user';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
      userList: [],
    };
  }

  componentDidMount() {
    this.getAccountList();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  getAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          userList: res.data,
        });
      }
    });
  };

  columns = () => {
    const {
      dataSource: { pagination },
      userList,
    } = this.state;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    let config = [
      {
        title: '编号',
        dataIndex: 'num',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '申请单号',
        dataIndex: 'no',
        render: (text, record) => {
          return (
            <Link to={`/incubator/oregistappMoveOut_manage/moveOut/open/${record.uuid}`}>
              {text}
            </Link>
          );
        },
      },
      {
        title: '孵化器',
        dataIndex: 'incubator',
        key: 'incubator',
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUser',
        key: 'createUser',
        render: text => {
          let name = '';
          userList.map(item => {
            if (item.uuid === text) {
              // eslint-disable-next-line prefer-destructuring
              name = item.name;
            }
            return item;
          });
          return name;
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '当前环节-处理人',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return <span>{currentActivity.uuid ? `${name || ''}-${processorName || ''}` : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          const status = record.instance ? record.instance.status : 2;
          if (status === 0) {
            return <span>审核中</span>;
          }
          if (status === 1) {
            return <span style={{ color: 'red' }}>已完成</span>;
          }
          return <span>待编辑</span>;
        },
      },
    ];
    if (this.props.type === 'mine') {
      config = config.filter(item => item.dataIndex !== 'createUserName');
    }
    return config;
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        loading={this.props.loading}
        rowKey="uuid"
        onChange={this.handleChange}
      />
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/TableSettled.js